import { createMuiTheme } from '@material-ui/core/styles';

const palette = {
  primary: { main: '#85C105' },
};
const themeName = 'Yle Theme';

export default createMuiTheme({ palette, themeName });
